<template>
	<TheStdLayout :title="$t('Lesson plan library')" :scrollable="false" :defaultPadding="false">
		<div class="flex flex-col h-full min-h-0">

			<!-- Tabs -->
			<LessonPlanLibraryTabs
				class="px-4 pt-4 border-l border-l-white"
				:activeTab="activeTab"
				@change="handleTabChange"
			/>

			<div class="overflow-y-auto flex-1 min-h-0">
				<router-view />
			</div>

		</div>
	</TheStdLayout>
</template>


<script lang="ts">
import LessonPlanLibraryTabs from "@/components/LessonPlanLibraryTabs.vue";
import { useDiscoverStateStore } from '@/stores/DiscoverCollections.store';
import { mapStores } from "pinia";

export default {
	name: 'LessonPlanLibrary', // important for router.getRootComponentName() which is used for context detection in certain child components

	components: {
		LessonPlanLibraryTabs,
	},

	tabRoutes: {
		'my-library': 'lesson-plan-library.my-library',
		'followed-authors': 'lesson-plan-library.followed-authors',
		'discover': 'lesson-plan-library.discover.home',
	},

	computed: {
		...mapStores(useDiscoverStateStore),

		activeTab(): string {
			// determine active tab based on current route
			const currentRouteName = this.$route.name as string;
			if (currentRouteName.startsWith('lesson-plan-library.discover')) {
				return 'discover';
			} else if (currentRouteName.startsWith('lesson-plan-library.followed-authors')) {
				return 'followed-authors';
			} else if (currentRouteName.startsWith('lesson-plan-library')) {
				return 'my-library';
			}
			return '';
		}
	},

	methods: {
		handleTabChange(tabName: string) {
			const goToRouteName = this.$options.tabRoutes[tabName];
			this.$router.push({ name: goToRouteName });
		},
	},
};
</script>
